import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import FontNumber from '../../../components/common/FontNumber'
import FlexBox from '../../../components/common/FlexBox'
import Side from '../../../components/order/Side'
import Filled from '../../../components/order/Filled'
import Status from '../../../components/order/Status'
import { withI18n } from '../../../i18n/util'

const Wrapper = styled.div`
  font-size: 14px;
  padding: 10px 5px;
  margin-top: 10px;
  box-shadow: rgba(90, 102, 124, 0.1) 0px 2px 10px 0px;
`

const Row = styled(FlexBox)`
  line-height: 22px;
  .title {
    width: 90px;
    text-align: left;
    color: #848e9c;
  }
  .value {
    width: 40%;
    text-align: left;
    color: #212833;
  }
`

const OrderHistoryMobileItem = ({ order, formatI18nText }) => (
  <Wrapper>
    <Row>
      <div className="title">{formatI18nText('exchange.pair')}</div>
      <div className="value">{order.pair}</div>
    </Row>
    <Row>
      <div className="title">{formatI18nText('exchange.side')}</div>
      <div className="value">
        <Side text={order.side} />
      </div>
    </Row>
    <Row>
      <div className="title">{formatI18nText('exchange.price')}</div>
      <div className="value">
        <FontNumber value={order.price} />
      </div>
    </Row>
    <Row>
      <div className="title">{formatI18nText('exchange.amount')}</div>
      <div className="value">
        <FontNumber value={order.amount} />
      </div>
    </Row>
    <Row>
      <div className="title">{formatI18nText('exchange.filled')}</div>
      <div className="value">
        <Filled value={order.filled} />
      </div>
    </Row>
    <Row>
      <div className="title">{formatI18nText('exchange.total')}</div>
      <div className="value">
        <FontNumber value={order.total} />
      </div>
    </Row>
    <Row>
      <div className="title">{formatI18nText('exchange.status')}</div>
      <div className="value">
        <Status text={order.status} />
      </div>
    </Row>
  </Wrapper>
)

OrderHistoryMobileItem.propTypes = {
  order: PropTypes.object,
  formatI18nText: PropTypes.func,
}

OrderHistoryMobileItem.defaultProps = {
  order: {},
  formatI18nText: () => {},
}

export default withI18n(OrderHistoryMobileItem)
